import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsCustomFieldsRoute: InvariantJiraRoute = {
	name: 'plan-settings-custom-fields',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields',
};
